import { AlulaEvent } from "@app/project/model/alula-event";
import { AlulaActions, AlulaReceiverActions, AlulaReceiverBindActions, AlulaReceiverGroupActions } from "@app/project/store/actions";
import { AlulaPanelState, initialAlulaPanelState } from "@app/project/store/projects.state";
import { LoadingState } from "@app/root-store/api-result.state";
import { objectify } from "@app/shared/resources/resource-objectifier";

export const alulaReducer = (
    state: AlulaPanelState = initialAlulaPanelState,
    action: AlulaActions.Actions | any = null
): AlulaPanelState => {
    switch (action.type) {
        case AlulaActions.ActionTypes.EnableSecurityMonitoring: {
            return {
                ...state,
                monitoringServices: { callState: LoadingState.loading },
            };
        }

        case AlulaActions.ActionTypes.LoadAlulaStateItem: {
            return {
                ...state,
                [action.payload]: {
                    ...state[action.payload],
                    callState:
                        state[action.payload].callState === LoadingState.init ? LoadingState.loading : state[action.payload].callState,
                },
            };
        }

        case AlulaActions.ActionTypes.LoadedAlulaStateItem: {
            return {
                ...state,
                [action.payload]: {
                    ...state[action.payload],
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaActions.ActionTypes.UpdateAlulaDeviceReceiverSuccess: {
            const devices = state?.activeReceiverGroupDevices?.result || [];
            const index = devices.findIndex(device => device.id === action.result.id);

            if (index >= 0) {
                devices.splice(index, 1);
            }

            return {
                ...state,
                activeReceiverGroupDevices: {
                    ...state.activeReceiverGroupDevices,
                    result: devices,
                },
                device: {
                    result: action.result,
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaActions.ActionTypes.CreateAlulaDeviceSuccess:
        case AlulaActions.ActionTypes.GetAlulaDeviceSuccess:
        case AlulaActions.ActionTypes.UpdateAlulaDeviceSuccess: {
            return {
                ...state,
                device: {
                    result: action.result,
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaActions.ActionTypes.CreateAlulaDeviceFailure:
        case AlulaActions.ActionTypes.GetAlulaDeviceFailure:
        case AlulaActions.ActionTypes.UpdateAlulaDeviceReceiverFailure: {
            return {
                ...state,
                device: {
                    result: null,
                    callState: {
                        error: action.error,
                    },
                },
            };
        }

        case AlulaActions.ActionTypes.ClearAlulaDevice: {
            return {
                ...state,
                device: {
                    result: null,
                    callState: LoadingState.init,
                },
            };
        }

        case AlulaActions.ActionTypes.GetDevicesByReceiverGroupIdSuccess: {
            return {
                ...state,
                activeReceiverGroupDevices: {
                    result: action.result,
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaActions.ActionTypes.GetDevicesByDealerIdSuccess: {
            return {
                ...state,
                activeAlarmReportingDevices: {
                    result: action.result,
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaActions.ActionTypes.EnableSecurityMonitoringSuccess: {
            action.result.device.customerId = action.result.user.id;
            return {
                ...state,
                device: {
                    result: action.result.device,
                    callState: LoadingState.loaded,
                },
                user: {
                    result: action.result.user,
                    callState: LoadingState.loaded,
                },
                monitoringServices: { callState: LoadingState.loaded },
            };
        }

        case AlulaActions.ActionTypes.EnableSecurityMonitoringFailure: {
            return {
                ...state,
                monitoringServices: { callState: LoadingState.loaded },
            };
        }

        case AlulaActions.ActionTypes.DisableSecurityMonitoring: {
            return {
                ...state,
                device: {
                    ...state.device,
                    callState: state.device.callState === LoadingState.init ? LoadingState.loading : state.device.callState,
                },
                monitoringServices: { callState: LoadingState.loading },
            };
        }

        case AlulaActions.ActionTypes.DisableSecurityMonitoringSuccess: {
            return {
                ...state,
                device: {
                    result: null,
                    callState: LoadingState.loaded,
                },
                monitoringServices: { callState: LoadingState.loaded },
            };
        }

        case AlulaActions.ActionTypes.DisableSecurityMonitoringFailure: {
            return {
                ...state,
                device: {
                    result: state.device.result,
                    callState: {
                        error: action.error,
                    },
                },
                monitoringServices: { callState: LoadingState.loaded },
            };
        }

        case AlulaActions.ActionTypes.CreateAlulaUserSuccess:
        case AlulaActions.ActionTypes.GetAlulaUserSuccess:
        case AlulaActions.ActionTypes.UpdateAlulaUserSuccess: {
            return {
                ...state,
                user: {
                    result: action.result,
                    callState: LoadingState.loaded,
                },
            };
        }
        case AlulaActions.ActionTypes.GetAlulaDeviceEventsSuccess: {
            return {
                ...state,
                events: objectify<AlulaEvent>(action.result),
            };
        }
        case AlulaActions.ActionTypes.CreateAlulaUserFailure:
        case AlulaActions.ActionTypes.GetAlulaUserFailure:
        case AlulaActions.ActionTypes.UpdateAlulaUserFailure: {
            return {
                ...state,
                user: {
                    result: null,
                    callState: {
                        error: action.error,
                    },
                },
            };
        }

        case AlulaReceiverActions.load.type: {
            return {
                ...state,
                receivers: {
                    result: state.receivers.result,
                    id: action.dealerId,
                    callState: LoadingState.loading,
                },
            };
        }

        case AlulaReceiverActions.loadSuccess.type: {
            return {
                ...state,
                receivers: {
                    result: action.receivers,
                    callState: LoadingState.loaded,
                    id: action.dealerId,
                },
            };
        }

        case AlulaReceiverActions.updateSuccess.type:
        case AlulaReceiverActions.createSuccess.type: {
            const filteredReceivers = { ...state.receivers.result };
            filteredReceivers[action?.receiver?.id] = action?.receiver;

            return {
                ...state,
                receivers: {
                    result: filteredReceivers,
                    callState: LoadingState.loaded,
                    id: action.dealerId,
                },
            };
        }
        case AlulaReceiverActions.deleteSuccess.type: {
            const filteredReceivers = { ...state.receivers.result };
            delete filteredReceivers[action?.receiver?.id];

            return {
                ...state,
                receivers: {
                    result: filteredReceivers,
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaReceiverGroupActions.load.type: {
            return {
                ...state,
                groups: {
                    result: state.groups.result,
                    callState: LoadingState.loading,
                    id: action.dealerId,
                },
            };
        }

        case AlulaReceiverGroupActions.loadSuccess.type: {
            return {
                ...state,
                groups: {
                    result: action.groups,
                    callState: LoadingState.loaded,
                    id: action.dealerId,
                },
            };
        }

        case AlulaReceiverGroupActions.updateSuccessSilent.type:
        case AlulaReceiverGroupActions.createSuccessSilent.type:
        case AlulaReceiverGroupActions.updateSuccess.type:
        case AlulaReceiverGroupActions.createSuccess.type: {
            const filteredGroups = [...state.groups.result];
            const index = filteredGroups.findIndex(grp => grp?.id === action?.group?.id);
            if (index >= 0) {
                filteredGroups.splice(index, 1);
            }
            return {
                ...state,
                groups: {
                    result: [...filteredGroups, action?.group],
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaReceiverGroupActions.deleteSuccess.type: {
            const filteredGroups = [...state.groups.result];
            const index = filteredGroups.findIndex(grp => grp?.id === action?.group?.id);
            if (index >= 0) {
                filteredGroups.splice(index, 1);
            }
            return {
                ...state,
                groups: {
                    result: filteredGroups,
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaReceiverBindActions.load.type: {
            return {
                ...state,
                binds: {
                    result: state.binds.result,
                    callState: LoadingState.loading,
                },
            };
        }

        case AlulaReceiverBindActions.loadSuccess.type: {
            return {
                ...state,
                binds: {
                    result: action.binds,
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaReceiverBindActions.updateSuccess.type:
        case AlulaReceiverBindActions.createSuccess.type: {
            const bindsGroup = state.binds.result[action?.bind?.receiverGroupId];
            const filteredBinds = !!bindsGroup ? [...bindsGroup] : [];
            const index = filteredBinds.findIndex(bind => bind?.id === action?.bind?.id);
            if (index >= 0) {
                filteredBinds[index] = action?.bind;
            }
            return {
                ...state,
                binds: {
                    result: {
                        ...state.binds.result,
                        [action?.bind?.receiverGroupId]: index >= 0 ? filteredBinds : [...filteredBinds, action.bind],
                    },
                    callState: LoadingState.loaded,
                },
            };
        }
        case AlulaReceiverBindActions.deleteSuccess.type: {
            const bindsGroup = state.binds.result[action?.receiverBind?.receiverGroupId];
            const filteredBinds = !!bindsGroup ? [...bindsGroup] : [];
            const index = filteredBinds.findIndex(bind => bind?.id === action?.receiverBind?.id);
            if (index >= 0) {
                filteredBinds.splice(index, 1);
            }
            return {
                ...state,
                binds: {
                    result: {
                        ...state.binds.result,
                        [action?.receiverBind?.receiverGroupId]: filteredBinds,
                    },
                    callState: LoadingState.loaded,
                },
            };
        }

        case AlulaActions.ActionTypes.ClearAlulaState: {
            return initialAlulaPanelState;
        }

        case AlulaActions.ActionTypes.ClearDevicesByDealerId: {
            return {
                ...state,
                activeReceiverGroupDevices: { result: null, callState: LoadingState.init },
                activeAlarmReportingDevices: { result: null, callState: LoadingState.init },
            };
        }

        case AlulaReceiverGroupActions.clear.type: {
            return {
                ...state,
                receivers: { result: null, callState: LoadingState.init },
                binds: { result: null, callState: LoadingState.init },
                groups: { result: null, callState: LoadingState.init },
                activeReceiverGroupDevices: { result: null, callState: LoadingState.init },
                activeAlarmReportingDevices: { result: null, callState: LoadingState.init },
            };
        }

        default: {
            return state;
        }
    }
};
